import { css } from "@emotion/react";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { T } from "../../../components/T";

export const NoSearchResultsParagraph: ReactTFC<{ text: React.ReactNode }> = props => {
  return (
    <p
      css={[
        FONTS.SwarovskiFutura300,
        fontColor.black,
        fontSize.x2,
        css`
          margin-bottom: 0;
        `,
      ]}
    >
      {props.text}
    </p>
  );
};
